import { Button } from "components/DesignSystem/Button/Button";
import { NotePencil } from "components/icons/NotePencil";
import { CrmNotes } from "components/serviceTeam/crmNotes";
import { useModal } from "hooks/useModal";
import React from "react";
import { EntityGroup } from "types/Models/bookkeepingTracker";

export const GroupNote = ({ group }: { group: EntityGroup }) => {
  const notedModal = useModal();

  return (
    <div>
      <Button customType="transparent" onClick={notedModal.open}>
        <NotePencil />
      </Button>
      {notedModal.isOpen && (
        <CrmNotes
          needDateInput
          showModal={notedModal.isOpen}
          closeModal={notedModal.close}
          clickedNote={group}
        />
      )}
    </div>
  );
};
